import type { ScreenModule } from "../../../app/screen-module";
import { LegalPage } from "../pages";

export default {
	id: "public.legal",
	path: "/legal/:pageId",
	area: "public",
	label: "規約・ポリシー",
	roles: [],
	backing: "MOCK_ONLY",
	enabled: true,
	component: LegalPage,
} satisfies ScreenModule;
